import { render, staticRenderFns } from "./UpdateEntityName.vue?vue&type=template&id=2e0ebba0&scoped=true"
import script from "./UpdateEntityName.vue?vue&type=script&lang=js"
export * from "./UpdateEntityName.vue?vue&type=script&lang=js"
import style0 from "./UpdateEntityName.vue?vue&type=style&index=0&id=2e0ebba0&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e0ebba0",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data/jenkins/data/workspace/KCC_AUDIT_PROD_Frontend/node_modules/vue-loader/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2e0ebba0')) {
      api.createRecord('2e0ebba0', component.options)
    } else {
      api.reload('2e0ebba0', component.options)
    }
    module.hot.accept("./UpdateEntityName.vue?vue&type=template&id=2e0ebba0&scoped=true", function () {
      api.rerender('2e0ebba0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/client-view/client-admin/components/UpdateEntityName.vue"
export default component.exports